import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { http } from "@/utils/http"
import { AxiosResponse } from "axios"
import {
  GET_ADD_CUSTOMERS_SUPPORT_URL,
  GET_UPDATE_DELETE_CUSTOMERS_SUPPORT_URL,
} from "@/constants/api/endpoints"
import {
  CustomerSupportFormType,
  CustomerSupportType,
} from "@/types/CustomerSupportType"


// Todo review the response from the update an the create function
interface FetchCustomerSupportsParams {
  type?: string;
}
// Fetch all customerSupports
export const fetchCustomerSupports = createAsyncThunk("manager/fetchCustomerSupports", async (params:FetchCustomerSupportsParams, thunkApi) => {
  return http
    .get<CustomerSupportType[]>(GET_ADD_CUSTOMERS_SUPPORT_URL, {params})
    .then((res): CustomerSupportType[] => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a manager
export const createAsyncCustomerSupport = createAsyncThunk<CustomerSupportType, CustomerSupportFormType>(
  "manager/createAsyncCustomerSupport",
  async (manager: Partial<CustomerSupportFormType>, thunkApi) => {
    return http
      .post<CustomerSupportType>(GET_ADD_CUSTOMERS_SUPPORT_URL, manager)
      .then((res): CustomerSupportType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing manager
export const updateAsyncCustomerSupport = createAsyncThunk<CustomerSupportType, {
  id?: string,
  data?: Partial<CustomerSupportFormType | FormData>,
}>(
  "manager/updateAsyncCustomerSupport",
  async ({ id, data }: {
    id?: string,
    data?: Partial<CustomerSupportFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<CustomerSupportType>(GET_UPDATE_DELETE_CUSTOMERS_SUPPORT_URL.replace(":id", `${id}`), data)
      .then((res): CustomerSupportType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing manager
export const deleteAsyncCustomerSupport = createAsyncThunk<AxiosResponse, { id: string }>(
  "manager/deleteAsyncCustomerSupport",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_CUSTOMERS_SUPPORT_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// initial state
const initialState: {
  customerSupports: CustomerSupportType[],
  customerSupportsStatus: string,
  customerSupportsErrors?: any,

  addCustomerSupportStatus: string,
  addCustomerSupportErrors?: any,

  deleteCustomerSupportErrors?: any,
  deleteCustomerSupportStatus: string,
} = {
  customerSupports: [],
  customerSupportsStatus: "idle",
  addCustomerSupportStatus: "idle",
  deleteCustomerSupportStatus: "idle",
}

const customerSupportsSlice = createSlice({
  name: "customerSupports",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all customerSupports
    builder
      .addCase(fetchCustomerSupports.pending, (state) => {
        state.customerSupportsStatus = "loading"
      })
      .addCase(fetchCustomerSupports.fulfilled, (state, action) => {
        state.customerSupportsStatus = "succeeded"
        state.customerSupports = action.payload
      })
      .addCase(fetchCustomerSupports.rejected, (state, action) => {
        state.customerSupportsStatus = "failed"
        state.customerSupportsErrors = action.error
      })

    builder
      .addCase(createAsyncCustomerSupport.pending, (state) => {
        state.addCustomerSupportStatus = "loading"
      })
      .addCase(createAsyncCustomerSupport.fulfilled, (state, action) => {
        state.addCustomerSupportStatus = "succeeded"
        state.customerSupports = [...state.customerSupports, action.payload]

      })
      .addCase(createAsyncCustomerSupport.rejected, (state, action) => {
        state.addCustomerSupportStatus = "failed"
        state.addCustomerSupportErrors = action.error
      })

    builder
      .addCase(updateAsyncCustomerSupport.pending, (state) => {
        state.customerSupportsStatus = "loading"
      })
      .addCase(updateAsyncCustomerSupport.fulfilled, (state, action) => {
        state.customerSupportsStatus = "succeeded"
        let index = state.customerSupports.findIndex(manager => manager.id === action.meta.arg.id)
        state.customerSupports[index] = action.payload
        // if (index >= 0) {
        //   state.customerSupports.splice(index, 1)
        //   state.customerSupports.reverse()
        //   state.customerSupports.unshift(action.payload)
        //   state.customerSupports.reverse()
        // }

      })
      .addCase(updateAsyncCustomerSupport.rejected, (state, action) => {
        state.customerSupportsStatus = "failed"
        state.customerSupportsErrors = action.error
      })

    builder
      .addCase(deleteAsyncCustomerSupport.pending, (state) => {
        state.deleteCustomerSupportStatus = "loading"
      })
      .addCase(deleteAsyncCustomerSupport.fulfilled, (state, action) => {
        state.customerSupportsStatus = "succeeded"
        state.customerSupports = state.customerSupports.filter((manager) => manager.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncCustomerSupport.rejected, (state, action) => {
        state.deleteCustomerSupportStatus = "failed"
        state.deleteCustomerSupportErrors = action.error
      })

  },
})

export default customerSupportsSlice.reducer

